import noop from 'lodash/noop';
import { createContext } from 'react';
import {
  ALL_FEATURE_FLAGS,
  ENVIRONMENT,
  type Environment,
  type FeatureFlags,
  featureFlagDescriptions,
} from 'utils/constants';
import { featureTogglesDefaultValues } from './FeatureTogglesDefaultValues';
import type { Features } from './FeatureTogglesProvider.types';

interface FeatureTogglesContext {
  readonly features: FeatureFlags;
  readonly isTogglingAllowed: boolean;
  readonly environmentsFeatureFlags: Record<string, FeatureFlags>;
  readonly environments: string[];
  readonly currentEnvironment: Environment;
  readonly featureFlagDescriptions: typeof featureFlagDescriptions;
  readonly setFeatures: (updater: (previousState: Features) => Features) => void;
}

const defaultContext: FeatureTogglesContext = {
  features: featureTogglesDefaultValues,
  environmentsFeatureFlags: ALL_FEATURE_FLAGS,
  currentEnvironment: ENVIRONMENT,
  setFeatures: noop,
  isTogglingAllowed: false,
  environments: [],
  featureFlagDescriptions,
};

export const FeatureTogglesContext = createContext(defaultContext);
